import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=a3e91adc&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=a3e91adc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e91adc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3e91adc')) {
      api.createRecord('a3e91adc', component.options)
    } else {
      api.reload('a3e91adc', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=a3e91adc&scoped=true&", function () {
      api.rerender('a3e91adc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24kNEcCpC97dY/JS/comp/GuestBox.vue"
export default component.exports